import { Heart } from "lucide-react";
import { useState, useRef, useEffect } from "react";

const CommentCard = ({ comment = {}, textSize = "14px" }) => {
  console.log("Current commen: ", comment);
  const {
    username = "user8351494235435",
    commentText = "My music taste is a mosaic of everyone I have ever loved",
    likes = "19.1K",
    hasHeart = true,
    viewSource,
  } = comment;

  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current) {
        const lineHeight = parseInt(
          window.getComputedStyle(textRef.current).lineHeight,
        );
        const height = textRef.current.scrollHeight;
        const lines = Math.round(height / lineHeight);
        setShowToggle(lines > 2);
      }
    };

    checkTextOverflow();
    window.addEventListener("resize", checkTextOverflow);
    return () => window.removeEventListener("resize", checkTextOverflow);
  }, [commentText]);

  {
    /* <div
                              key={cidx}
                              className="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white px-2 py-1 sm:flex-row sm:items-center"
                            >
                              <div className="flex flex-1 flex-col">
                                <span className="text-xs font-bold text-gray-800">
                                  {comment.user.name || "Missing"}
                                </span>
                                <span className="text-xs text-gray-700">
                                  {comment.text || "Missing"}
                                </span>
                              </div>
                              <div className="flex min-w-[36px] flex-col items-center gap-1 text-xs font-semibold text-[#DB4225]">
                                <svg
                                  width="18"
                                  height="18"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                                      2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
                                      4.5 2.09C13.09 3.81 14.76 3 16.5 
                                      3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                                      6.86-8.55 11.54L12 21.35z"
                                    fill="#DB4225"
                                  />
                                </svg>
                                <span>~{comment.likes} </span>
                              </div>
                            </div> */
  }

  return (
    <div className="w-full rounded-2xl border border-gray-200 bg-white px-2 py-1 shadow-sm">
      <div className="flex items-start justify-between">
        {/* Left section with username and comment text */}
        <div className="flex-1 text-left">
          <div className="mb-1 text-[13px] font-semibold text-black">
            @{username || "Missing"}
          </div>
          <div
            className="text-left font-normal leading-relaxed text-[#1F263E]"
            style={{ fontSize: textSize }}
          >
            <div
              ref={textRef}
              className={`${
                !isExpanded && showToggle ? "line-clamp-2 overflow-hidden" : ""
              }`}
              style={{
                display: "-webkit-box",
                WebkitLineClamp: !isExpanded && showToggle ? 2 : "none",
                WebkitBoxOrient: "vertical",
                overflow: !isExpanded && showToggle ? "hidden" : "visible",
              }}
            >
              {commentText}
            </div>

            {showToggle && (
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="mt-1 text-[13px] font-medium text-red-500 transition-all hover:text-red-300 focus:outline-none"
              >
                {isExpanded ? "Show less" : "Show more"}
              </button>
            )}
          </div>
        </div>

        {/* Right section with like icon, count, and optional view source */}
        <div className="mb-1 ml-4 mr-2 mt-1 flex flex-col items-end gap-1">
          {hasHeart ? (
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                fill="#DB4225"
              />
            </svg>
          ) : null}
          <div className="text-sm font-semibold text-[#DB4225]">~{likes}</div>
          {viewSource && (
            <a
              href={viewSource}
              className="text-sm text-red-500 underline hover:text-gray-700"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Source
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommentCard;
